import type { VoidFunctionComponent } from 'react';

import { ResizableFileTreeLayout } from '../../../generic/ResizableFileTreeLayout/ResizableFileTreeLayout';
import VendoredPathTreeFilter from '../filters/VendoredPathTreeFilter';
import type useDependencyModals from '../hooks/useDependencyModals';

import VendoredTableContents from './VendoredTableContents';
import VendoredTableHeader from './VendoredTableHeader';

import styles from './VendoredDependenciesLayout.module.less';

type Props = {
  revisionLocator: string;
  modals: ReturnType<typeof useDependencyModals>;
  setSelectedDependencyRevisionLocator: (locator: string | null) => void;
  removeDependency: (locator: string, isManual: boolean) => void;
  setDependencyLocatorToEdit: (locator: string | null) => void;
  setInProgressBuildId: (buildId: number | null) => void;
  handleOverwriteManualDependency: (overwriteDependencyLocator: string) => void;
};

/**
 * Layout component for the vendored dependencies view with tree navigation.
 * Uses ResizableFileTreeLayout for a resizable file-tree column + table.
 */
const VendoredDependenciesLayout: VoidFunctionComponent<Props> = ({
  revisionLocator,
  modals,
  setSelectedDependencyRevisionLocator,
  removeDependency,
  setDependencyLocatorToEdit,
  setInProgressBuildId,
  handleOverwriteManualDependency,
}) => {
  const handleSetSelectedLocator = (locator: string) => {
    setSelectedDependencyRevisionLocator(locator);
  };

  return (
    <div className={styles.fileTreeLayout}>
      <ResizableFileTreeLayout
        treeHeader="Files"
        contentHeader={<VendoredTableHeader />}
        renderTree={({ width, height }) => (
          <VendoredPathTreeFilter
            revisionLocator={revisionLocator}
            width={width}
            height={height}
          />
        )}
      >
        <VendoredTableContents
          modals={modals}
          setSelectedDependencyRevisionLocator={handleSetSelectedLocator}
          removeDependency={removeDependency}
          setDependencyLocatorToEdit={setDependencyLocatorToEdit}
          setInProgressBuildId={setInProgressBuildId}
          handleOverwriteManualDependency={handleOverwriteManualDependency}
        />
      </ResizableFileTreeLayout>
    </div>
  );
};

export default VendoredDependenciesLayout;
